import IndexHolidayDate from "./IndexHolidayDate.vue";
import DetailHolidayDate from "./DetailHolidayDate.vue";
import CreateHolidayDate from "./CreateHolidayDate.vue";
import UpdateHolidayDate from "./UpdateHolidayDate.vue";
import UploadHolidayDate from "./UploadHolidayDate.vue";


let routes= [
    
    {
        path: '',
        meta: {
          title: "Chain Holiday Date",
        },
        name: "CtIndexHolidayDate",
        component: IndexHolidayDate
    },
    {
    path: 'detail/:id',
    meta: {
        title: "OMS Holiday Date Detail",
    },
    name: "CtDetailHolidayDate",
    component: DetailHolidayDate
    },
    {
    path: 'update/:id',
    meta: {
        title: "OMS Holiday Date Update",
    },
    name: "CtUpdateHolidayDate",
    component: UpdateHolidayDate
    },
    {
    path: 'upload',
    meta: {
        title: "OMS Holiday Date Upload",
    },
    name: "CtUploadHolidayDate",
    component: UploadHolidayDate
    },
    {
    path: 'create',
    meta: {
        title: "OMS Holiday Date Create",
    },
    name: "CtCreateHolidayDate",
    component: CreateHolidayDate
    },
    
  ]
  
  export default routes
  